import script from "./PlThemeSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./PlThemeSwitch.vue?vue&type=script&setup=true&lang=js"

import "./PlThemeSwitch.vue?vue&type=style&index=0&id=2c7cf2d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c7cf2d6"]])

export default __exports__